import React from 'react';

function valueOrDash(value) {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return value;
}

export function getWorkScheduleJobSummaryFields(workSchedule) {
  if (!workSchedule?.id) {
    return null;
  }
  const salesOrder = workSchedule?.sales_order_detail?.sales_order || {};
  const consignee = salesOrder?.consignee || {};
  const customer = consignee?.customer || {};
  const soNo = `${salesOrder.prefix || ''}${salesOrder.order_no || ''}`.trim();
  return [
    { label: 'Schedule No', value: workSchedule.schedule_no },
    { label: 'Date', value: workSchedule.delivery_date || workSchedule.schedule_date },
    { label: 'SO No', value: soNo },
    { label: 'SO Date', value: salesOrder.order_date },
    { label: 'Customer', value: customer.name },
    { label: 'Site', value: consignee.project_name || consignee.name },
    { label: 'Schedule Qty', value: workSchedule.scheduled_qty },
    { label: 'Marketing', value: customer.salesrep?.name },
  ];
}

export function WorkScheduleJobSummary({ workSchedule }) {
  const fields = getWorkScheduleJobSummaryFields(workSchedule);
  if (!fields) {
    return null;
  }

  return (
    <div className="pump-job-summary">
      {fields.map((field) => (
        <div className="pump-job-summary-item" key={field.label}>
          <span className="pump-job-summary-label">{field.label}</span>
          <span className="pump-job-summary-value">{valueOrDash(field.value)}</span>
        </div>
      ))}
    </div>
  );
}
